import(/* webpackMode: "eager", webpackExports: ["Payment"] */ "/home/tlk/tlk-pay-yookasa/tlk-pay-yookasa/src/widgets/Payment/Payment.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PaymentFaq"] */ "/home/tlk/tlk-pay-yookasa/tlk-pay-yookasa/src/widgets/PaymentFaq/PaymentFaq.tsx");
